import { defineComponent as _defineComponent } from 'vue'
import { useBriefcaseStore } from "@/pinia/briefcase";
import { computed, ref } from "vue";
import { BriefcaseFolder, VignetteRoutes } from "@/types";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { RouterService } from "@/services";
import { Dictionary } from "vue-router/types/router";
import { useRoute, useRouter } from "vue-router/composables";
import DeleteBriefcaseFolderDialog from "@/components/dialogs/DeleteBriefcaseFolderDialog.vue";
import AddNewBriefcaseFolderDialog from "@/components/dialogs/AddNewBriefcaseFolderDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BriefcaseFolderSelect',
  props: {
    selectedFolders: null
  },
  emits: ["update-folders"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update-folders", folders: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedFolders?: number[];
};





const isInSelectMode = computed(() => props.selectedFolders !== undefined);
// makes typescript happy when modifying currentFolder
const isInSelectModeGuard = (
  currentFolder: undefined | number[] | number
): currentFolder is number[] => {
  return isInSelectMode.value;
};

const router = useRouter();
const route = useRoute();

const briefcaseStore = useBriefcaseStore();
const briefcaseFolders = computed(() => briefcaseStore.flatFoldersSorted);
const currentFolder = computed(() =>
  isInSelectMode.value
    ? props.selectedFolders
    : briefcaseStore.meta.currentFolderId
);

const handleChange = (folderId: number | number[]) => {
  if (isInSelectMode.value) {
    emit("update-folders", folderId as number[]);
  } else {
    navigateToFolder(folderId as number);
  }
};
const navigateToFolder = (folderId: number) => {
  const isSubFolder = folderId !== briefcaseStore.meta.defaultFolderId;
  const params: Dictionary<string> = isSubFolder
    ? { folderId: String(folderId) }
    : {};

  briefcaseStore.meta.currentFolderId = folderId;
  RouterService.navigateByName(
    router,
    isSubFolder ? VignetteRoutes.BriefcaseFolder : VignetteRoutes.Briefcase,
    route.query,
    params
  );
};

const handleNewFolder = (folder: BriefcaseFolder) => {
  if (isInSelectModeGuard(currentFolder.value)) {
    currentFolder.value?.push(folder.id);
  }
  displayAddFolderDialog.value = false;
};

const displayAddFolderDialog = ref(false);

const folderToBeDeleted = ref<BriefcaseFolder | null>(null);
const displayDeleteFolderDialog = computed(() => !!folderToBeDeleted.value?.id);
const setFolderToBeDeletedAndDisplayDialog = (folder: BriefcaseFolder) => {
  folderToBeDeleted.value = folder;
};

return { __sfc: true,emit, props, isInSelectMode, isInSelectModeGuard, router, route, briefcaseStore, briefcaseFolders, currentFolder, handleChange, navigateToFolder, handleNewFolder, displayAddFolderDialog, folderToBeDeleted, displayDeleteFolderDialog, setFolderToBeDeletedAndDisplayDialog, NjBtn, DeleteBriefcaseFolderDialog, AddNewBriefcaseFolderDialog }
}

})